import React from "react";
import { useParams } from "react-router-dom";
import Profile_users from "./profile_users"; // import file con
import National_market from '../process/national_market.jsx';
import { Cookies } from '../../index.js';
import Authenticator from "./authenticator"; // import file con

const ProfileUsers = () => {
    const { slug_1 } = useParams(); // Lấy slug_1 từ URL, ví dụ /reactapp/profile/:slug_1
    const national_market = Cookies.get("national_market");

    if (slug_1 === "auth") {
        return <>
            <Authenticator />
        </>;
    } else {
        return <>
            {
                <Profile_users />
            }
        </>;
    }
};

export default ProfileUsers;
